import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_iuf_select = _resolveComponent("iuf-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: "text-body2",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_iuf_select, _mergeProps({
      options: _ctx.valueOptions,
      "allow-create": _ctx.canCreateIGValue && _ctx.isAllowedToCreate,
      "placeholder-value": _ctx.isMultiple ? _ctx.t('PLACEHOLDER.SELECT_MULTIPLE') : _ctx.t('PLACEHOLDER.SELECT_SINGLE'),
      "option-label": "label",
      "option-value": "dobjId",
      removable: "",
      "selected-item-slot": ""
    }, _ctx.isMultiple ? _ctx.SELECT_MULTIPLE_MD_SEARCH : _ctx.SELECT_SINGLE_MD_SEARCH, {
      modelValue: _ctx.selectedValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValue) = $event)),
      onFilter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterOptions({ ...$event }))),
      onCreateValue: _ctx.createIGFieldListValue
    }), {
      "selected-item": _withCtx((scope) => [
        (_openBlock(), _createBlock(_component_iap_chip, {
          tooltip: "",
          label: scope.opt.label,
          key: scope.opt.dobjId,
          removable: "",
          onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
        }, null, 8, ["label", "onRemove"]))
      ]),
      _: 1
    }, 16, ["options", "allow-create", "placeholder-value", "modelValue", "onCreateValue"])
  ]))
}